import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "16",
  height: "16",
  x: "2",
  y: "2",
  fill: "#17ADCE",
  rx: "2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M10.662 13.775v-.754c.164-.005.297-.019.398-.043a.316.316 0 0 0 .227-.156c.05-.08.074-.212.074-.394V11.06c0-.148.016-.295.047-.44a.77.77 0 0 1 .219-.384c.114-.112.288-.19.52-.234a1.087 1.087 0 0 1-.427-.164.752.752 0 0 1-.238-.262 1.06 1.06 0 0 1-.097-.312 2.267 2.267 0 0 1-.024-.32V7.571c0-.182-.025-.314-.074-.394a.331.331 0 0 0-.227-.157 2.135 2.135 0 0 0-.398-.042v-.754c.159 0 .316.006.473.02.159.012.31.038.453.077.143.037.27.094.379.172.109.076.195.177.257.305.066.127.098.288.098.48v1.528c0 .138.014.265.043.382.029.118.102.211.219.282.117.07.31.105.578.105v.848c-.247 0-.431.031-.55.094a.449.449 0 0 0-.235.27 1.36 1.36 0 0 0-.055.41v1.527c0 .192-.032.351-.098.476a.796.796 0 0 1-.261.309c-.11.078-.236.135-.38.172a2.29 2.29 0 0 1-.452.074c-.157.013-.313.02-.47.02M9.346 13.775a5.84 5.84 0 0 1-.477-.02 2.283 2.283 0 0 1-.449-.073 1.163 1.163 0 0 1-.383-.172.843.843 0 0 1-.261-.309 1.064 1.064 0 0 1-.094-.476v-1.528c0-.14-.015-.27-.043-.386a.447.447 0 0 0-.219-.282c-.117-.07-.311-.105-.582-.105v-.848c.268 0 .461-.035.578-.105a.445.445 0 0 0 .223-.282 1.61 1.61 0 0 0 .043-.382V7.279c0-.192.031-.353.094-.48a.809.809 0 0 1 .261-.305c.112-.078.239-.135.38-.172.142-.039.293-.065.452-.078.16-.013.317-.02.473-.02v.755c-.164.005-.298.02-.402.042a.345.345 0 0 0-.23.157c-.048.08-.071.212-.071.394v1.371c0 .105-.008.213-.024.325a.957.957 0 0 1-.101.312.726.726 0 0 1-.235.258c-.104.075-.246.13-.425.164.18.034.321.088.425.164a.686.686 0 0 1 .235.258.958.958 0 0 1 .101.312c.016.11.024.218.024.324v1.368c0 .182.023.313.07.394.05.084.126.136.23.157.105.023.24.037.407.043z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }